const menu = [
  {
    name: 'Websites',
    value: 'front-end',
  },
  {
    name: 'APIs',
    value: 'back-end',
  },
  // {
  //   name: 'Full Stack',
  //   value: 'full-stack',
  // },
];

export default menu;
